import React from 'react';
import { X, FileText, Download, Printer } from 'lucide-react';

// Quarterly Goals Content
const quarterlyGoalsContent = `# QUARTERLY GOALS REPORT - Q1 2024
## SLIK POS - Barber Performance & Growth Strategy

### 📊 BARBER: JOSE - ELITE PERFORMER
#### Q1 2024 (January - March)

## 🎯 QUARTERLY OBJECTIVES

### FINANCIAL GOALS
- **Revenue Target:** $42,349 (15% growth over Q4 2023 average)
- **Monthly Breakdown:**
  - January: $13,500
  - February: $14,000
  - March: $14,849
- **Average Ticket Goal:** $48 (current: $45.85)

### CLIENT METRICS
- **Total Clients Target:** 885 (10% growth)
- **New Client Acquisition:** 120
- **Retention Rate Goal:** 93% (current: 92%)
- **Rebooking Rate Target:** 90% (current: 88%)

### SERVICE & PRODUCT GOALS
- **Services per Client:** 1.5 average
- **Product Sales Target:** $4,500
- **Upsell Rate:** 25% of appointments
- **Premium Service Ratio:** 35%

[View full document in Goals Management section for complete weekly breakdowns, AI tasks, and strategies]
`;

interface QuarterlyGoalsViewerProps {
  isOpen: boolean;
  onClose: () => void;
  barberName: string;
}

const QuarterlyGoalsViewer: React.FC<QuarterlyGoalsViewerProps> = ({
  isOpen,
  onClose,
  barberName
}) => {
  if (!isOpen) return null;

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    const element = document.createElement('a');
    const file = new Blob([quarterlyGoalsContent], { type: 'text/markdown' });
    element.href = URL.createObjectURL(file);
    element.download = `QUARTERLY-GOALS-${barberName}-Q1-2024.md`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-gray-900 rounded-2xl shadow-2xl w-full max-w-6xl h-[90vh] flex flex-col">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-700">
          <div className="flex items-center">
            <FileText className="h-6 w-6 text-purple-500 mr-3" />
            <h2 className="text-2xl font-bold text-gray-100">
              Quarterly Goals Report - Q1 2024
            </h2>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={handleDownload}
              className="px-4 py-2 bg-blue-500/20 text-blue-400 rounded-lg hover:bg-blue-500/30 transition-all flex items-center"
            >
              <Download className="h-4 w-4 mr-2" />
              Download
            </button>
            <button
              onClick={handlePrint}
              className="px-4 py-2 bg-green-500/20 text-green-400 rounded-lg hover:bg-green-500/30 transition-all flex items-center"
            >
              <Printer className="h-4 w-4 mr-2" />
              Print
            </button>
            <button
              onClick={onClose}
              className="p-2 bg-gray-700 rounded-lg hover:bg-gray-600 transition-all"
            >
              <X className="h-5 w-5 text-gray-300" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto p-6">
          <div className="prose prose-invert max-w-none">
            <pre className="whitespace-pre-wrap text-gray-300 font-mono text-sm bg-gray-800 p-6 rounded-lg">
              {quarterlyGoalsContent}
            </pre>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuarterlyGoalsViewer;